(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  // Header functionality
  document.addEventListener('DOMContentLoaded', function() {
    const header = document.querySelector('.header');
    const cartBtn = document.querySelector('[data-open-cart]');

    const ensureCartCountEl = function() {
      if (! cartBtn) return


      


      let el = cartBtn.querySelector('.header__cart-count');
      if (! el) {
        el = document.createElement('span');
        el.className = 'header__cart-count';
        cartBtn.appendChild(el);
      }
      return el;
    };

    const updateCartCount = function(count) {
      const countNum = typeof count === 'number'
        ? count
        : 0;
      const existing = cartBtn ?. querySelector('.header__cart-count');

      if (countNum > 0) {
        const el = existing || ensureCartCountEl();
        if (! el) return;
        


        el.textContent = String(countNum);
      } else if (existing) {
        existing.remove();
      }
    };

// Initial cart count update
    const initialCount = cartBtn ?. querySelector('.header__cart-count') ?. getAttribute('data-cart-count');
    updateCartCount(
      initialCount
        ? parseInt(initialCount, 10)
        : 0
    );

// Handle scroll effects
    let lastScrollTop = 0;

    window.addEventListener('scroll', function() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > 100) {
        header.style.background = 'rgba(255, 255, 255, 0.1)';
        header.style.boxShadow = '0 2px 20px rgba(0, 0, 0, 0.1)';
      } else {
        header.style.background = 'rgba(255, 255, 255, 0.1)';
        header.style.boxShadow = 'none';
      } lastScrollTop = scrollTop;
    });

// Cart button functionality - now handled by CartManager
    if (cartBtn) {

// Remove old click handler - CartManager handles this via data-open-cart
// The CartManager will automatically handle opening the drawer
    }

// Listen for cart updates from CartManager
    document.addEventListener('cart:fetched', function(e) {
      const cartData = e.detail;
      if (cartData && typeof cartData.item_count === 'number') {
        updateCartCount(cartData.item_count);
      }
    });

// Listen for cart item additions
    document.addEventListener('cart:item-added', function(e) {

// CartManager will automatically fetch updated cart data
// and trigger cart:fetched event
    });

// Listen for cart quantity changes
    document.addEventListener('cart:quantity-changed', function(e) {

// CartManager will automatically fetch updated cart data
// and trigger cart:fetched event
    });

// Listen for cart count updates (optimistic updates)
    document.addEventListener('cart:count-updated', function(e) {
      const cartData = e.detail;
      if (cartData && typeof cartData.count === 'number') {
        updateCartCount(cartData.count);
      }
    });

// Listen for external cart updates
    document.addEventListener('cart:external-update', function(e) {

// CartManager will automatically fetch updated cart data
// and trigger cart:fetched event
    });

// Listen for cart errors
    document.addEventListener('cart:error', function(e) {
      console.error('Cart error:', e.detail);
    });

// Initialize cart count when CartManager is ready
    if (window.CartManager && window.CartManager.isInitialized()) {
      const cart = window.CartManager.getCart();
      if (cart) {
        updateCartCount(cart.item_count);
      }
    } else { // Wait for CartManager to be ready
      document.addEventListener('cart:fetched', function(e) {
        const cartData = e.detail;
        if (cartData && typeof cartData.item_count === 'number') {
          updateCartCount(cartData.item_count);
        }
      }, {once: true});
    }
  });

  } catch(e) { console.error(e); }
})();
})();
